import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {API_ENTITIES} from '../config/urls';
import {ClientDTO} from '@dto/entities/clients-dto.model';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  private readonly http = inject(HttpClient);

  getEntities(): Observable<ClientDTO[]> {
    return this.http.get<ClientDTO[]>(API_ENTITIES, { observe: 'response' }).pipe(
      map(response => response.body ?? [])
    );
  }
}
